import EditCommentModal from "./EditCommentModal";
import { useBoolean } from '@laxmimanogna/code-quick-components';
import DeleteCommentModal from "./DeleteCommentModal";
import CommentBox from "./CommentBox";
import { Box, Divider, HStack, Menu, MenuButton, MenuItem, MenuList, Skeleton, Spinner, Stack, Text } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useContext, useState } from "react";
import { AuditSheetContext } from "../../../../providers/AuditSheetProvider";
import AppColors from "../../../../constants/AppColors";

const CommentList = ({ onOpenNotes, batchId }) => {
    const auditSheetContext = useContext(AuditSheetContext);
    const { allComments, isAllCommentLoading, commentFilters, totalComments } =
        auditSheetContext;
    const [isEditCommentOpen, iecoState] = useBoolean(false)
    const [isDeleteCommentOpen, idcoState] = useBoolean(false)
    const [selectedComment, setSelectedComment] = useState({})
    const [selectedParentComment, setSelectedParentComment] = useState({})

    const renderCommentLoading = () => {
        return [0, 1, 2, 3, 5].map(p => <Stack key={p} mb={5}>
            <Skeleton height="100px" />
        </Stack>)
    }

    // Nest any top-level reply items into their parent's reply_comments,
    // then filter to only Notes and Rebuttals (hide old cell-wise comments).
    const nestedComments = (() => {
        const parentMap = {};
        const parents = [];

        allComments.forEach(c => {
            if (!c.parent) {
                parentMap[c.id] = { ...c, reply_comments: [...(c.reply_comments || [])] };
                parents.push(parentMap[c.id]);
            }
        });

        allComments.forEach(c => {
            if (c.parent && parentMap[c.parent]) {
                const already = parentMap[c.parent].reply_comments.some(r => r.id === c.id);
                if (!already) {
                    parentMap[c.parent].reply_comments.push(c);
                }
            }
        });

        return parents;
    })();

    // Show only Notes (no rows, no cols) and Rebuttals (action=REBUTTAL).
    // Hide ADD/DELETE activity log entries, old cell-wise comments, and
    // any other OPEN+rows threads that are not rebuttals.
    const visibleComments = nestedComments
        .filter(c =>
            (!c.audit_sheet_rows?.length && !c.audit_sheet_columns?.length) ||
            c.action === 'REBUTTAL'
        )
        .sort((a, b) => {
            const dateA = new Date(a.commented_date || 0);
            const dateB = new Date(b.commented_date || 0);
            return commentFilters.reverse ? dateB - dateA : dateA - dateB;
        });

    if (isAllCommentLoading && !visibleComments.length) {
        return renderCommentLoading()
    }
    if (!isAllCommentLoading && !visibleComments.length) {
        return <Box height={'100%'} display='flex' alignItems={'center'} justifyContent='center'>
            <Text color={AppColors.primary}>
                No Notes & Activity here yet!
            </Text>
        </Box>
    }
    return <>
        <HStack justifyContent='flex-end' mb={2}
        >
            {/* <Menu>
                <MenuButton
                    px={4}
                    py={2}
                    transition='all 0.2s'
                    borderRadius='md'
                    borderWidth='1px'
                    mb={2}
                >
                    {commentFilters.sheet_name ? 'Current Sheet' : 'All Sheets'} <ChevronDownIcon />
                </MenuButton>
                <MenuList>
                    <MenuItem onClick={() => {
                        onOpenNotes({ current: true })
                    }}>Current Sheet</MenuItem>
                    <MenuItem onClick={() => {
                        onOpenNotes({ all: true })
                    }}>All Sheets</MenuItem>
                </MenuList>
            </Menu> */}
        </HStack>

        {visibleComments.map((comment, index) => (
            <CommentBox
                key={comment.id ?? index}
                comment={comment}
                index={index}
                onEditModalOpen={iecoState.on}
                onDeleteModalOpen={idcoState.on}
                setSelectedComment={setSelectedComment}
                selectedComment={selectedComment}
                setSelectedParentComment={setSelectedParentComment}
                batchId={batchId}
            />
        ))}
        {isAllCommentLoading && visibleComments.length > 0 && (
            <Box display='flex' justifyContent='center' py={4}>
                <Spinner size='sm' color={AppColors.primary} />
            </Box>
        )}
        <EditCommentModal isOpen={isEditCommentOpen} onClose={() => {
            iecoState.off()
        }} selectedComment={selectedComment} selectedParentComment={selectedParentComment} />
        <DeleteCommentModal isOpen={isDeleteCommentOpen} onClose={() => {
            idcoState.off()
        }} selectedComment={selectedComment} selectedParentComment={selectedParentComment} />
    </>

}
export default CommentList